import React, { useState } from 'react';
import { X } from 'lucide-react';

const DeclineKYCModal = ({ isOpen, onClose, onSubmit }) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(reason);
    setReason('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 w-full">
      <div className="bg-white rounded-2xl p-6 w-full max-w-96 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        {/* Modal content */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold font-sans">Decline KYC Request</h2>
          
          <form onSubmit={handleSubmit} className="flex flex-col">
            <div>
              <label className="block text-sm text-gray-600 mb-2 font-sans">
                Reason for declining
              </label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full h-40 p-3 border border-gray-200 font-sans rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                placeholder="Enter reason"
              />
            </div>

            <button
              type="submit"
              className="py-3 px-3 my-4 w-56 bg-emerald-800 text-white rounded-full hover:bg-emerald-700 transition-colors self-center"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeclineKYCModal